import {createContext} from "react";

export default createContext({
	languagePairGroups: [],
	loading: false,
	getLanguagePairGroups: () => {}
});